import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import classes from '../../assets/scss/common.module.css';
import { Icons } from '../../assets';

const ModalDropdown = (props) => {
  const {
    isOpen,
    closePopUp,
    notifymodal = false,
    timeOutModal = false,
    boxAlign,
    className,
    closeOnOutsideClick = true,
    hideCloseIcon = false,
  } = props;
  const [isExiting, setIsExiting] = useState(false);
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!closeOnOutsideClick) {
        return;
      }
      const { target } = event;
      const clickedInsideModal = modalRef.current && modalRef.current.contains(target);
      const clickedInsideDropdown =
        props.selectBoxRef?.current && props.selectBoxRef.current.contains(target);
      const safeClasses = ['MuiPopover-root'];
      const clickedInsideSafeElements = safeClasses.some((className) =>
        target.closest(`.${className}`)
      );

      if (!clickedInsideModal && !clickedInsideDropdown && !clickedInsideSafeElements) {
        closeModal();
      } else {
        //Click inside modal, dropdown, or a safe element. Keeping it open.
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, closePopUp, closeOnOutsideClick]);

  useEffect(() => {
    if (timeOutModal && isOpen) {
      setTimeout(() => {
        closeModal();
      }, 3500);
    }
  }, [timeOutModal]);

  const closeModal = () => {
    if (isOpen) {
      setIsExiting(true);
      setTimeout(() => {
        setIsExiting(false);
        closePopUp();
      }, 300);
    }
  };

  const centerAlignClass = boxAlign === 'center' ? classes.boxCenterAlign : '';
  const overlayAnimState = isExiting ? classes.isExiting : classes.isOpen;
  const overlayAnimClass = isOpen || isExiting ? overlayAnimState : '';

  const wrapperClasses = [
    classes.modalDropdownWrapper,
    notifymodal ? classes.notifymodal : '',
    boxAlign === 'center' ? classes.boxCenterAlign : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  const overlayClasses = ['modal-overlay', classes.modalOverlay, centerAlignClass, overlayAnimClass]
    .filter(Boolean)
    .join(' ');

  const content = (
    <div className={overlayClasses}>
      <div className={wrapperClasses} ref={modalRef}>
        {boxAlign === 'center' && !hideCloseIcon && (
          <button onClick={closeModal}>
            <img
              src={Icons.cross}
              className='float-right cursor-pointer absolute right-[16px] top-4 h-[12px] w-[12px]'
              onClick={() => closeModal()}
            />
          </button>
        )}
        {props.children}
      </div>
    </div>
  );

  return typeof document !== 'undefined' ? createPortal(content, document.body) : content;
};

export default ModalDropdown;
